module.exports = __webpack_public_path__ + "q.no1.fc416c08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/q.no1.jpg
// module id = uya1
// module chunks = 0